import Servico from "../../../../../Models/Financeiro/Faturamento/Servico";
import ServicoServices from "../../../../../Services/Financeiro/Faturamento/ServicoServices";
import { ISelectComPesquisaProps, SelectComPesquisa } from "../../../../SelectComPesquisa";
interface IServicoSelectProps extends ISelectComPesquisaProps {
    ativo?:boolean;
    servico?:Servico;
}
export default function ServicoSelect({
    ativo,
    servico,
    placeholder,
    loading,
    allowClear,
    ...props
}:IServicoSelectProps) {
    ativo = ativo ?? true;
    
    const {
        data,
        isLoading
    } = ServicoServices.useListar({
        ativo,
        servico 
    });

    return <SelectComPesquisa
        {...props}
        allowClear={allowClear ?? true}
        placeholder={placeholder ?? "Selecione"}
        loading={loading ?? isLoading}
        options={
            data?.map(m => {
                return {
                    label: m.nome,
                    value: m.codigo
                };
            })
        } 
    />
}